import { useState } from 'react'
import { cn } from '@/lib/utils'

/** Two letters for an app with no icon: the first letters of the first two
 *  words, or the first two of a single word. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return Array.from(parts[0]).slice(0, 2).join('').toUpperCase()
  return (Array.from(parts[0])[0] + Array.from(parts[1])[0]).toUpperCase()
}

/** An app's icon, rounded like the store draws it. Without an icon (or when
 *  it fails to load) it shows the app's initials on a muted square. */
export function AppIcon({ src, name, size = 28, className }: { src?: string | null; name: string; size?: number; className?: string }) {
  const [broken, setBroken] = useState(false)
  const radius = Math.round(size * 0.225)
  const style = { width: size, height: size, borderRadius: radius }
  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        onError={() => setBroken(true)}
        style={style}
        className={cn('shrink-0 border border-border object-cover', className)}
      />
    )
  }
  return (
    <span
      aria-hidden
      style={{ ...style, fontSize: Math.max(9, Math.round(size * 0.38)) }}
      className={cn('inline-flex shrink-0 select-none items-center justify-center bg-muted font-semibold text-muted-foreground', className)}
    >
      {initials(name)}
    </span>
  )
}
